import { routes } from "@constants/routes";
import { Pagination, Typography } from "@cpj-ai/panel-npm-package";
import { GetJobPositionsQuery } from "@graphql/generated";
import { useNavigate } from "react-router-dom";
import JobPositionTable from "./jobPositionTable";

interface JobPositionListProps {
  jobPositions?: GetJobPositionsQuery;
  currentPage: number;
  pageSize: number;
  onPageChange: (page: number) => void;
  onPageSizeChange?: (pageSize: number) => void;
  onRowClick?: (id?: string) => void;
  showPageSize?: boolean;
}

const JobPositionList: React.FC<JobPositionListProps> = ({
  jobPositions,
  currentPage,
  pageSize,
  onPageChange,
  onPageSizeChange,
  onRowClick,
  showPageSize = true,
}) => {
  const navigate = useNavigate();

  const jobPositionsList = jobPositions?.admin?.jobPositions?.edges?.map((item) => ({
    ...item?.node,
  }));

  const handleRowClick = (jobPositionId: string) => {
    if (onRowClick) {
      onRowClick(jobPositionId);
    } else {
      navigate(routes.jobPositions.view.replace(":id", jobPositionId));
    }
  };

  return (
    <div className="h-fit w-full">
      {jobPositionsList?.length ? (
        <div className="flex flex-col items-center gap-6 w-full">
          <JobPositionTable jobPositions={jobPositions} onRowClick={handleRowClick} />
          <Pagination
            total={jobPositions?.admin?.jobPositions?.totalCount ?? 0}
            page={currentPage}
            onChange={onPageChange}
            onPageSizeChange={onPageSizeChange}
            pageSize={pageSize}
            showPageSize={showPageSize}
          />
        </div>
      ) : (
        <div className="pt-40 w-full flex justify-center items-center">
          <Typography variant="muted">There is no job post </Typography>
        </div>
      )}
    </div>
  );
};

export default JobPositionList;
